export const CARD_BRAND_DEF_GET = "/CardBrandDef/GetAllCardBrandDef"